import Pqp from "../3x1010/Pqp.js";
//import Sounder from "./Tools/sounder/Sounder";
import MainLoop from "./Tools/MainLoop";
import Spran from "./Tools/spran/Spran";
import Controls from "./Tools/controls/Controls";
import Main from "./Main.js";
import Sounder from "../3x1010/sounder/Sounder.js";

export default class Game {
  constructor(idtheme, deaths, maxDistance, isAngry, callback) {
    this.clipsDebris = new Array();
    this.clipsSpearmen = new Array();
    this.cornholioStatus = Game.STATUS_CORNHOLIO_RUN;
    this.tickFire = 0;
    this.callback = callback;
    this.isFiring = true;
    this.currentCoverCount = 0;
    this.theme = idtheme;
    this.canCreateSpearmen = true;
    this.soundSpears = 0;
    this.currentLevel = 0;
    this.totalTick = 0;
    this.themeDuration = NaN;
    this.isDead = false;
    this.canFire = true;
    this.spearsOrigin = new Array();
    this.spearsOriginHistory = new Array();
    this.deaths = deaths;
    this.maxDistance = maxDistance;
    this.isAngry = isAngry;
    this.seeked = false;
    this.spears = 0;
    jQuery(".js-main").removeClass("black");
    jQuery(".js-main").addClass("blue");


  }

  init() {
    this.createSection();
    this.createControls();
    this.createDebris();
    this.createPyramid();
    this.createLeftSpearmen()
    this.createRightSpearmen()
    this.createCornholio();
    this.updateDeaths();
    this.showAngryMessage();
    if (this.deaths >= 3) {
      jQuery(".js-give-up",this.mc).show();
      jQuery(".js-give-up", this.mc).on("click",this.giveUp.bind(this));
    }

    jQuery(window).on("resize.game", this.onResize.bind(this));

    this.startTheme();
    this.initListeners();
    MainLoop.subscribe(this, "onMainLoop", MainLoop.PRIORITY_MAIN);
    MainLoop.start();
  }

  giveUp() {
    //if (!Main.savegame.rickrolled) {
//      Main.savegame.rickrolled = true;
      window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ", "_blank");
  //  }

    for (let x = 0; x < 4; x++) {
      //Sounder.stop("spear" + x);
      Main.that.sounder.stop("spear" + x);
    }
    //Sounder.stop(this.theme);
    Main.that.sounder.stop(this.theme);
    this.dispatch({ type: Game.EVENT_GIVEUP })
  }

  showAngryMessage() {
    if (this.isAngry) {
      this.isAngry = false;
      let mex = Game.getNextAngryMessage();
      this.showMessage(mex);
    }
  }

  showSpurMessage() {
    let mex = this.getNextSpurMessage();
    this.showMessage(mex);
  }

  showMessage(mex) {
    let clipMessage = jQuery("#template-message").clone();
    clipMessage.removeAttr("id");
    clipMessage.text(mex);
    jQuery(".js-upper", this.mc).append(clipMessage);
    this.idto = setTimeout(this.removeMessage.bind(this, clipMessage), 4000);
    if (Main.savegame.flash) {
      requestAnimationFrame(this.blinkMessage.bind(this, clipMessage, 0, 0));
    }

  }

  blinkMessage(clip, index, mod) {
    mod++;
    if (mod % 4 === 0) {
      index++;
      if (index >= Game.BLINK_COLORS.length) {
        index = 0;
      }
      clip.css("color", Game.BLINK_COLORS[index]);
      if (clip.is(":visible")) {
        requestAnimationFrame(this.blinkMessage.bind(this, clip, index,mod));
      }
    } else {
      requestAnimationFrame(this.blinkMessage.bind(this, clip, index, mod));
    }
  }


  removeMessage(clipMessage) {
    clipMessage.remove();
  }

  static getNextAngryMessage() {
    if (!Game.angry) {
      Game.angry = new Array();
    }
    if (Game.angry.length === 0) {
      Game.angry = Game.MESSAGES_ANGRY.slice();
      Pqp.shuffle(Game.angry);
      Pqp.shuffle(Game.angry);
    }
    return Game.angry.pop();
  }

  getNextSpurMessage() {
    if (!this.spur) {
      this.spur = new Array();
    }
    if (this.spur.length === 0) {
      this.spur = Game.MESSAGES_SPUR.slice();
      Pqp.shuffle(this.spur);
      Pqp.shuffle(this.spur);
    }
    return this.spur.pop();
  }


  updateDeaths() {
    jQuery(".js-deaths", this.mc).text("" + this.deaths)
    jQuery(".js-max-distance-text", this.mc).text(this.maxDistance + "%");
    if (this.maxDistance === 0) {
      jQuery(".js-max-distance", this.mc).hide();
    }
  }

  initListeners() {
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    jQuery(window).on("blur", this.onMinimize.bind(this));
    jQuery(window).on("focus", this.onMaximize.bind(this));
  }

  onMinimize() {
    //Sounder.pauseAll();
    //Sounder.pause(this.theme);
    for (let x = 0; x < 4; x++) {
      //Sounder.stop("spear" + x);
      Main.that.sounder.pause("spear" + x);
    }
    //Sounder.stop(this.theme);
    Main.that.sounder.pause(this.theme);
    Main.that.sounder.pause("intro");


    MainLoop.pause();
    TweenMax.pauseAll();
  }
  onMaximize() {
    //Sounder.resume(this.theme);
//    Sounder.resumeAll();
    for (let x = 0; x < 4; x++) {
      //Sounder.stop("spear" + x);
      Main.that.sounder.resume("spear" + x);
    }
    //Sounder.stop(this.theme);
    Main.that.sounder.resume(this.theme);
    Main.that.sounder.resume("intro");


    MainLoop.resume();
    TweenMax.resumeAll();
  }


  startTheme() {
    //Sounder.play(this.theme, this.themeEnded.bind(this));
    Main.that.sounder.play(this.theme,true,false,false, this.themeEnded.bind(this));
  }

  createSection() {
    this.mc = jQuery("#template-game-screen").clone();
    this.mc.removeAttr("id");
    jQuery(".js-main").append(this.mc);
  }

  destroy() {
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    jQuery(window).off("resize.game");
    MainLoop.stop();
    MainLoop.unsubscribe(this);
    MainLoop.unsubscribe(this.pyramid);
    MainLoop.unsubscribe(this.cornholio);
    if (this.cornholioDead) {
      MainLoop.unsubscribe(this.cornholioDead);
    }
    for (let x = 0; x < this.clipsDebris.length; x++) {
      MainLoop.unsubscribe(this.clipsDebris[x].spran)
    }
    for (let x = 0; x < this.clipsSpearmen.length; x++) {
      MainLoop.unsubscribe(this.clipsSpearmen[x].spran)
    }

    this.mc.remove();
    this.controls.destroy();

  }

  onMainLoop() {
    if (isNaN(this.themeDuration)) {
      //this.themeDuration = Sounder.getDuration(this.theme);
      this.themeDuration = Main.that.sounder.getDuration(this.theme)/1000;
      //console.log(this.themeDuration)
    }
    this.checkCornholioStatus()
    this.tickFire++;
    this.totalTick++;
    this.manageDebrisCover();
    if (!isNaN(this.themeDuration)) {
      if (Game.beginNearEnd) {
        if (!this.seeked) {
          this.seeked = true;
          //Sounder.seek(this.theme, this.themeDuration - 4)
          Main.that.sounder.setStartTime(this.theme, this.themeDuration - 4)
        }
      }


      this.checkLevel();
    }

  }

  checkLevel() {
    //this.currentLevel = Math.floor(this.totalTick * MainLoop.FPS_LIMIT / 1000)
    if (Game.beginNearEnd) {
      this.distance = 100;
      jQuery(".js-distance", this.mc).text(this.distance + "%")
      this.currentLevel = Game.LEVELS.length-1;
      this.updatePyramid();
      return;
    }


    let elapsed = (Math.floor(this.totalTick / MainLoop.FPS_LIMIT));

    let perc = 0;
    for (let x = 0; x <= this.currentLevel; x++) {
      perc += Game.LEVELS[x].lasts;
    }

    if (!this.isDead) {

      this.distance = Math.floor((elapsed / this.themeDuration) * 100);
      if (this.distance > 100) {
        this.distance = 100;
      }
      jQuery(".js-distance", this.mc).text(this.distance + "%")
    }

    if (perc < 1) {
      let value = this.themeDuration * perc;
      //console.log(elapsed + " " + value);
      if (elapsed > value) {
        this.currentLevel++;
        this.updatePyramid();
        this.showSpurMessage();
      }
    }
    //this.tickFire % Math.floor(100 * MainLoop.FPS_LIMIT / 1000)
  }


  manageDebrisCover() {
    if (this.currentCoverCount === 8) {

      return
    }

    if (this.currentCoverCount === 7) {
      this.tickFire = 118;
      this.currentCoverCount++;
      if (!Game.DEBUG_NO_FIRE) {
        this.isFiring = false;
      }
      jQuery(".js-debris-start-cover", this.mc).remove();
    }

    if (this.tickFire % Math.floor(100 * MainLoop.FPS_LIMIT / 1000) === 0) {
      this.currentCoverCount++;
      for (let x = 0; x < 4; x++) {
        jQuery(".js-cover-" + x, this.mc).addClass("cover-" + x + "-step-" + this.currentCoverCount);
      }
    }
  }

  createControls() {
    this.controls = new Controls(this);
    this.controls.init();
    this.controls.enable(true);
  }


  onResize() {
    for (let x = 0; x < this.clipsDebris.length; x++) {
      this.clipsDebris[x].spran.pause();
      MainLoop.unsubscribe(this.clipsDebris[x].spran)
      this.clipsDebris[x].div.remove();
    }
    this.clipsDebris = new Array();
    this.createDebris();
  }

  createPyramid() {
    let div = jQuery(".js-pyramid", this.mc);
    let anim = JSON.parse(JSON.stringify(Game.PYRAMID));
    let spran = new Spran(div, anim);
    spran.init();
    spran.setAnimation("level0")
    MainLoop.subscribe(spran)
    this.pyramid = spran;
  }

  updatePyramid() {
    this.pyramid.setAnimation("level" + this.currentLevel);
  }


  createDebris() {
    let lCondExit = false;
    let x = 0 - 4;
    while (!lCondExit) {
      let div = jQuery("#template-lower-debris").clone();
      div.removeAttr("id");
      jQuery(".js-debris", this.mc).append(div);
      div.css("left", x);
      x += div.width();
      let anim = JSON.parse(JSON.stringify(Game.DEBRIS));

      let spran = new Spran(div, anim);
      spran.init();
      spran.setAnimation("default")
      MainLoop.subscribe(spran)

      if (x > jQuery(window).width()) {
        lCondExit = true;
      }

      this.clipsDebris.push({ div: div, spran: spran });

    }

    lCondExit = false;
    x = jQuery(window).width() / 2;
    while (!lCondExit) {

      let div = jQuery("#template-upper-debris").clone();
      div.removeAttr("id");
      jQuery(".js-debris", this.mc).append(div);
      div.css("left", x);
      x += div.width();

      let anim = JSON.parse(JSON.stringify(Game.DEBRIS));
      anim[0].sheet = "debris1";
      let spran = new Spran(div, anim);
      spran.init();
      spran.setAnimation("default")
      MainLoop.subscribe(spran)

      if (x > jQuery(window).width()) {
        lCondExit = true;
      }
      this.clipsDebris.push({ div: div, spran: spran });
    }

    lCondExit = false;
    x = jQuery(window).width() / 2;
    while (!lCondExit) {

      let div = jQuery("#template-upper-debris").clone();
      div.removeAttr("id");
      jQuery(".js-debris", this.mc).append(div);
      x -= div.width();
      div.css("left", x);


      let anim = JSON.parse(JSON.stringify(Game.DEBRIS));
      anim[0].sheet = "debris2";
      anim[0].flip = true;
      let spran = new Spran(div, anim);
      spran.init();
      spran.setAnimation("default")
      MainLoop.subscribe(spran)

      if (x < 0) {
        lCondExit = true;
      }
      this.clipsDebris.push({ div: div, spran: spran });

    }

    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_DEAD) {
      for (let x = 0; x < this.clipsDebris.length; x++) {
        this.clipsDebris[x].spran.pause();
      }
    }

  }


  createRightSpearmen() {

    let o;
    o = this.createNextRightSperamen()
    o.spran.setAnimation("frame14")
    o = this.createNextRightSperamen()
    o.spran.setAnimation("frame9")
    o = this.createNextRightSperamen()
    o.spran.setAnimation("frame4")


  }

  createLeftSpearmen() {
    let o;
    o = this.createNextLeftSperamen()
    o.spran.setAnimation("frame14")
    o = this.createNextLeftSperamen()
    o.spran.setAnimation("frame9")
    o = this.createNextLeftSperamen()
    o.spran.setAnimation("frame4")
  }




  createNextRightSperamen() {
    let div = jQuery("#template-spearmen").clone();
    let id = "sp" + Game.ENUM++
    div.attr("id", id);
    jQuery(".js-lower", this.mc).append(div);

    let anim = JSON.parse(JSON.stringify(Game.SPEARMEN));
    let spran = new Spran(div, anim, this.spranRightEventsHandler.bind(this, div));
    spran.init();
    spran.setAnimation("frame0");
    MainLoop.subscribe(spran)

    let o = { div: div, spran: spran }
    this.clipsSpearmen.push(o);

    return o;

  }

  spranRightEventsHandler(div, e) {
    if (e.type === Spran.EVENT_START_ANIMATION) {
      let id = e.data.anim.id;
      if (id === "frame5") {
        if (this.canCreateSpearmen) {
          this.createNextRightSperamen();
        }
      }

      let pos = this.getSpearmenAnimationPos(id);
      if (pos) {
        div.css("top", pos.top);
        div.css("left", pos.left);
      } else {
        this.removeSpearmen(div);
      }


    }

  }

  getSpearmenAnimationPos(id) {
    for (let x = 0; x < Game.SPEARMEN_POS.length; x++) {
      if (Game.SPEARMEN_POS[x].id === id) {
        return Game.SPEARMEN_POS[x];
      }
    }
    return null;
  }


  createNextLeftSperamen() {
    let div = jQuery("#template-spearmen").clone();
    let id = "sp" + Game.ENUM++
    div.attr("id", id);
    jQuery(".js-lower", this.mc).append(div);

    let anim = JSON.parse(JSON.stringify(Game.SPEARMEN));
    for (let x = 0; x < anim.length; x++) {
      anim[x].flip = true;
    }

    let spran = new Spran(div, anim, this.spranLeftEventsHandler.bind(this, div));
    spran.init();
    spran.setAnimation("frame0");
    MainLoop.subscribe(spran)
    let o = { div: div, spran: spran };
    this.clipsSpearmen.push(o);
    return o;
  }

  spranLeftEventsHandler(div, e) {
    if (e.type === Spran.EVENT_START_ANIMATION) {
      let id = e.data.anim.id;
      if (id === "frame5") {
        if (this.canCreateSpearmen) {
          this.createNextLeftSperamen();
        }
      }

      let pos = this.getSpearmenAnimationPos(id);
      if (pos) {
        div.css("top", pos.top);
        let tmp = parseFloat(pos.left.split("%")[0]);
        let left = 100 - tmp - 7.3;
        left = left + "%"
        div.css("left", left);
      } else {
        this.removeSpearmen(div);
      }
    }

  }



  removeSpearmen(div) {
    let id = div.attr("id");
    for (let x = 0; x < this.clipsSpearmen.length; x++) {
      if (this.clipsSpearmen[x].div.attr("id") === id) {
        MainLoop.unsubscribe(this.clipsSpearmen[x].spran)
        this.clipsSpearmen.splice(x, 1);
        break;
      }
    }
    div.remove();
    this.checkFire();
  }

  checkFire() {
    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_DEAD) {
      return;
    }
    if (this.distance >= 99) {
      return;
    }

    //    console.log("CHECK")
    //console.log(this.tickFire)
    if (this.tickFire >= this.getSpearTimeForLevel()) {
      if (!this.isFiring) {
        this.isFiring = true;
        this.fire();
      }
    }

  }

  getSpearTimeForLevel() {
    let level = Game.LEVELS[this.currentLevel];
    if (Game.EASIER) {
      return level.spear + 30;
    }

    return level.spear;
  }


  fire() {
    if (!this.canFire) {
      return
    }

    let spear = jQuery("#template-spear").clone();
    spear.removeAttr("id");
    jQuery(".js-lower", this.mc).append(spear);

    let anim = JSON.parse(JSON.stringify(Game.SPEAR));
    let n = this.getNextSpearOrigin();
    let start = 0 - Math.floor(spear.width() / jQuery(window).width() * 100);
    let end = 100;
    let lFromLeft = true;
    let lUp = true;
    //n = 2;
    if (n === 0) {
      spear.addClass("spear-up")
      anim[0].flip = true;
      start = 100;
      end = 0 - Math.floor(spear.width() / jQuery(window).width() * 100);
      lFromLeft = false;
    } else if (n === 1) {
      anim[0].flip = true;
      spear.addClass("spear-down")
      start = 100;
      end = 0 - Math.floor(spear.width() / jQuery(window).width() * 100);
      lUp = false;
      lFromLeft = false;
    } else if (n === 2) {
      spear.addClass("spear-up")
    } else {
      spear.addClass("spear-down")
      lUp = false;
    }
    let spran = new Spran(spear, anim);
    spran.init();
    spran.setAnimation("default");

    spear.css("left", start + "%");
    TweenMax.to(spear, this.getSpearTime(), { left: end + "%", ease: Linear.easeNone, onUpdate: this.checkHit.bind(this, spear, spran, lFromLeft, lUp), onComplete: this.removeSpear.bind(this, spear, spran, lFromLeft, lUp) });

    //Sounder.play("spear" + this.soundSpears);
    Main.that.sounder.play("spear" + this.soundSpears);
    if (this.soundSpears < 3) {
      this.soundSpears++;
    }
  }

  getSpearTime() {
    if (Game.EASIER) {
      let perc = (100-this.distance) / 100;
      let time = Game.ARROW_TIME_ALT + 0.4 * perc;
      //console.log(time);
      return time;
    }
    return Game.ARROW_TIME;
  }


  getNextSpearOrigin() {
    let n = Pqp.rnd(3);
    if (this.spearsOrigin.indexOf(n) >= 0) {
      if (this.spearsOrigin.length > 2) {
        let n1 = Pqp.rnd(3);
        while (n1 === n) {
          n1 = Pqp.rnd(3);
        }
        this.spearsOrigin = new Array();
        this.spearsOrigin.push(n1);
        n = n1;
      } else {
        this.spearsOrigin.push(n);
      }
    } else {
      this.spearsOrigin = new Array();
      this.spearsOrigin.push(n);
    }

    this.spearsOriginHistory.push(n);
    return n;

  }

  checkHit(spear, spran, lFromLeft, lUp) {

    if (Game.invincible) {
      return;
    }

    // 38,52
    let percs = Math.floor(spear.width() / jQuery(window).width() * 100);
    let left = parseInt(spear.css("left"));
    let perc = Math.floor(left / jQuery(window).width() * 100);
    if (lFromLeft) {
      if ((perc >= 38) && (perc <= 38 + percs)) {
        if (lUp) {
          if (this.cornholioStatus !== Game.STATUS_CORNHOLIO_CROUCH) {
            let id = "nw";
            let anim = this.cornholio.getCurrentAnimName();
            let perc = 0;
            if (anim === "jump") {
              let frame = this.cornholio.getCurrentFrame();
              if (frame === 0 || frame === 6) {
                perc = 1;
              } else if (frame === 1 || frame === 5) {
                perc = 2;
              } else if (frame === 2 || frame === 3) {
                perc = 3;
              } else if (frame === 3) {
                perc = 4;
              }
            }
            if (perc !== 0) {
              id = "sw";
            }

            // Dead!
            this.removeSpear(spear, spran);
            this.die(id, perc)
          }
        } else {
          if (this.cornholioStatus !== Game.STATUS_CORNHOLIO_JUMP) {
            // Dead!
            this.removeSpear(spear, spran);
            this.die("sw", 0)
          }
        }
      }
    } else {
      if ((perc <= 52) && (perc >= 52 - percs)) {
        if (lUp) {
          if (this.cornholioStatus !== Game.STATUS_CORNHOLIO_CROUCH) {
            let id = "ne";
            let anim = this.cornholio.getCurrentAnimName();
            let perc = 0;
            if (anim === "jump") {
              let frame = this.cornholio.getCurrentFrame();
              if (frame === 0 || frame === 6) {
                perc = 1;
              } else if (frame === 1 || frame === 5) {
                perc = 2;
              } else if (frame === 2 || frame === 3) {
                perc = 3;
              } else if (frame === 3) {
                perc = 4;
              }
            }

            if (perc !== 0) {
              id = "se";
            }

            // Dead!
            this.removeSpear(spear, spran);
            this.die(id, perc)
          }
        } else {
          if (this.cornholioStatus !== Game.STATUS_CORNHOLIO_JUMP) {
            // Dead!
            this.removeSpear(spear, spran);
            this.die("se", 0)
          }
        }

      }
    }
  }

  removeSpear(spear, spran, fromLeft) {
    spran.pause();
    spear.remove();
    this.spears++;
    this.tickFire = 0;
    this.isFiring = false;
  }


  checkCornholioStatus() {

    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_DEAD) {
      return;
    }

    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_RUN) {
      if (this.controls.n) {
        this.cornholioStatus = Game.STATUS_CORNHOLIO_JUMP;
        this.controls.reset();
        this.cornholio.setAnimation("jump");
      }
      if (this.controls.s) {
        this.cornholioStatus = Game.STATUS_CORNHOLIO_CROUCH;
        this.cornholio.setAnimation("crouch");
      }
    }
    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_JUMP) {
      this.controls.reset();
    }

    if (this.cornholioStatus === Game.STATUS_CORNHOLIO_CROUCH) {
      if (!this.controls.s) {
        this.cornholioStatus = Game.STATUS_CORNHOLIO_RUN;
        this.cornholio.setAnimation("run");
      }
    }

  }

  cornholioEventsHandler(e) {
    if (e.type === Spran.EVENT_END_ANIMATION) {
      if (e.data.anim.id === "jump") {
        this.cornholioStatus = Game.STATUS_CORNHOLIO_RUN;
      }
    }

  }




  createCornholio() {
    let div = jQuery(".js-cornholio", this.mc);
    let anim = JSON.parse(JSON.stringify(Game.CORNHOLIO));
    let spran = new Spran(div, anim, this.cornholioEventsHandler.bind(this));
    spran.init();
    spran.setAnimation("run");
    MainLoop.subscribe(spran)
    this.cornholio = spran;
  }

  die(idAnim, incUp) {
    this.isDead = true;
    jQuery(".js-deaths", this.mc).text("" + (this.deaths + 1))
    for (let x = 0; x < 4; x++) {
///      Sounder.stop("spear" + x);
      Main.that.sounder.stop("spear" + x);
    }
    //Sounder.play("death");
    Main.that.sounder.play("death");


    for (let x = 0; x < this.clipsDebris.length; x++) {
      this.clipsDebris[x].spran.pause();
    }
    for (let x = 0; x < this.clipsSpearmen.length; x++) {
      this.clipsSpearmen[x].spran.pause();
    }
    this.cornholioStatus = Game.STATUS_CORNHOLIO_DEAD;

    this.cornholio.pause();
    jQuery(".js-cornholio", this.mc).hide();

    let div = jQuery(".js-cornholio-dead", this.mc);
    div.addClass("cornholio-dead-up-" + incUp);


    div.show();
    if (idAnim.indexOf("e") >= 0) {
      div.addClass("cornholio-dead-e");
    } else {
      div.addClass("cornholio-dead-w");
    }

    let anim = JSON.parse(JSON.stringify(Game.CORNHOLIO_DEAD));
    let spran = new Spran(div, anim, this.cornholioDeadEventsHandler.bind(this));
    spran.init();
    spran.setAnimation(idAnim);
    MainLoop.subscribe(spran)
    this.cornholioDead = spran;


  }
  cornholioDeadEventsHandler(e) {
    if (e.type === Spran.EVENT_END_ANIMATION) {
      //Sounder.stop(this.theme);
      Main.that.sounder.stop(this.theme)
      this.cornholioDead.pause();
      this.dispatch({ type: Game.EVENT_DEAD })
    }
  }

  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }


  themeEnded(e) {
    if (this.isDead) {
      return;
    }
    //if (e.type === Sounder.EVENT_SOUND_ENDED) {
      this.cornholio.setAnimation("run");
      this.controls.destroy();
      this.stopSpearmen();
      //Sounder.play("intro", this.outroEnded.bind(this));
      Main.that.sounder.play("intro", true,false,false,this.outroEnded.bind(this));
      TweenMax.to(this.cornholio.clip, 5, { delay: 4, scaleX: 0, scaleY: 0, bottom: "46%" });
      jQuery(".js-debris-end-cover", this.mc).show();
      TweenMax.to(jQuery(".js-debris-end-cover", this.mc), 2, { delay: 2, height: "100%", ease: Power1.easeIn });
    //}
  }

  stopSpearmen() {
    this.isFiring = true;
    this.canCreateSpearmen = false;
    this.canFire = false;

  }

  outroEnded(e) {
    //if (e.type === Sounder.EVENT_SOUND_ENDED) {
      this.dispatch({ type: Game.EVENT_WON })
      MainLoop.stop();
    //}
  }

}

Game.CORNHOLIO = [
  {
    id: "run",
    sheet: "cornholio",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 120 },
      { row: 0, col: 1, time: 120 },
    ]
  },
  {
    id: "jump",
    sheet: "cornholio",
    flip: false,
    frames: [
      { row: 0, col: 2, time: 80 },
      { row: 0, col: 3, time: 100 },
      { row: 0, col: 4, time: 150 },
      { row: 0, col: 5, time: 100 },
      { row: 0, col: 6, time: 80 },
      { row: 0, col: 7, time: 80 },
      { row: 0, col: 8, time: 80 },
      { row: 0, col: 9, time: 20 },
      { goto: "run" }
    ]
  },
  {
    id: "crouch",
    sheet: "cornholio",
    flip: false,
    frames: [
      { row: 0, col: 10, time: 120 },
      { row: 0, col: 11, time: 120 },
    ]
  },

]

Game.CORNHOLIO_DEAD = [
  {
    id: "se",
    sheet: "dead",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 60 },
      { row: 0, col: 1, time: 60 },
      { row: 0, col: 2, time: 60 },
      { row: 0, col: 3, time: 60 },
      { row: 0, col: 4, time: 1000 },
    ]
  },
  {
    id: "ne",
    sheet: "dead",
    flip: false,
    frames: [
      { row: 1, col: 0, time: 60 },
      { row: 1, col: 1, time: 60 },
      { row: 1, col: 2, time: 60 },
      { row: 1, col: 3, time: 60 },
      { row: 1, col: 4, time: 1000 },
    ]
  },
  {
    id: "nw",
    sheet: "dead",
    flip: false,
    frames: [
      { row: 2, col: 0, time: 60 },
      { row: 2, col: 1, time: 60 },
      { row: 2, col: 2, time: 60 },
      { row: 2, col: 3, time: 60 },
      { row: 2, col: 4, time: 1000 },
    ]
  },
  {
    id: "sw",
    sheet: "dead",
    flip: false,
    frames: [
      { row: 3, col: 0, time: 60 },
      { row: 3, col: 1, time: 60 },
      { row: 3, col: 2, time: 60 },
      { row: 3, col: 3, time: 60 },
      { row: 3, col: 4, time: 1000 },
    ]
  },
]


Game.PYRAMID = [
  {
    id: "level0",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 },
    ]
  },
  {
    id: "level1",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 1, col: 0, time: 100 },
    ]
  },
  {
    id: "level2",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 2, col: 0, time: 100 },
    ]
  },
  {
    id: "level3",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 3, col: 0, time: 100 },
    ]
  },
  {
    id: "level4",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 4, col: 0, time: 100 },
    ]
  },
  {
    id: "level5",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 5, col: 0, time: 100 },
    ]
  },
  {
    id: "level6",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 6, col: 0, time: 100 },
    ]
  },
  {
    id: "level7",
    sheet: "pyramid",
    flip: false,
    frames: [
      { row: 7, col: 0, time: 100 },
    ]
  },
]




Game.DEBRIS = [
  {
    id: "default",
    sheet: "debris0",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 },

      { row: 0, col: 1, time: 100 },
      { row: 1, col: 0, time: 100 },
      { row: 1, col: 1, time: 100 },
      { row: 2, col: 0, time: 100 },
      { row: 2, col: 1, time: 100 },
      { row: 3, col: 0, time: 100 },
      { row: 3, col: 1, time: 100 },
      { row: 4, col: 0, time: 100 },
      { row: 4, col: 1, time: 100 },
      { row: 5, col: 0, time: 100 },
      { row: 5, col: 1, time: 100 },
      { row: 6, col: 0, time: 100 },
      { row: 6, col: 1, time: 100 },
      { row: 7, col: 0, time: 100 },
      { row: 7, col: 1, time: 100 },
      { row: 8, col: 0, time: 100 },
      { row: 8, col: 1, time: 100 },
      { row: 9, col: 0, time: 100 }

    ]
  },

]

Game.SPEAR = [
  {
    id: "default",
    sheet: "spear",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 }
    ]
  }
]


Game.SPEARMEN_TIME = 110;

Game.SPEARMEN_POS = [
  { left: "51%", top: "-32.8%", id: "frame0" },
  { left: "52.5%", top: "-31.7%", id: "frame1" },
  //{ left: "53.7%", top: "-31.8%", id: "frame1" },
  { left: "55%", top: "-30.4%", id: "frame2" },
  { left: "56.2%", top: "-27.6%", id: "frame3" },
  { left: "57.5%", top: "-27.6%", id: "frame4" },
  { left: "59.0%", top: "-26.0%", id: "frame5" },
  { left: "59.5%", top: "-25.2%", id: "frame6" },
  { left: "61.8%", top: "-23.7%", id: "frame7" },
  { left: "64.0%", top: "-22.6%", id: "frame8" },
  { left: "65.9%", top: "-20.4%", id: "frame9" },
  { left: "68.2%", top: "-19.6%", id: "frame10" },
  { left: "70.6%", top: "-17.0%", id: "frame11" },
  { left: "73.4%", top: "-15.3%", id: "frame12" },
  { left: "76.2%", top: "-13.6%", id: "frame13" },
  { left: "78.5%", top: "-11.3%", id: "frame14" },
  { left: "81.8%", top: "-8.5%", id: "frame15" },
  { left: "84.7%", top: "-6.2%", id: "frame16" },
  { left: "88.5%", top: "-3.4%", id: "frame17" },
  { left: "92.2%", top: "-2.2%", id: "frame18" }
]


Game.SPEARMEN = [
  {
    id: "frame0",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 0, time: Game.SPEARMEN_TIME },
      { goto: "frame1" }
    ]
  },
  {
    id: "frame1",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 1, time: Game.SPEARMEN_TIME },
      { goto: "frame2" }
    ]
  },
  {
    id: "frame2",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 2, time: Game.SPEARMEN_TIME },
      { goto: "frame3" }
    ]
  },
  {
    id: "frame3",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 3, time: Game.SPEARMEN_TIME },
      { goto: "frame4" }
    ]
  },
  {
    id: "frame4",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 4, time: Game.SPEARMEN_TIME },
      { goto: "frame5" }
    ]
  },
  {
    id: "frame5",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 5, time: Game.SPEARMEN_TIME },
      { goto: "frame6" }
    ]
  },
  {
    id: "frame6",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 6, time: Game.SPEARMEN_TIME },
      { goto: "frame7" }
    ]
  },
  {
    id: "frame7",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 7, time: Game.SPEARMEN_TIME },
      { goto: "frame8" }
    ]
  },
  {
    id: "frame8",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 8, time: Game.SPEARMEN_TIME },
      { goto: "frame9" }
    ]
  },
  {
    id: "frame9",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 9, time: Game.SPEARMEN_TIME },
      { goto: "frame10" }
    ]
  },
  {
    id: "frame10",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 10, time: Game.SPEARMEN_TIME },
      { goto: "frame11" }
    ]
  },
  {
    id: "frame11",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 11, time: Game.SPEARMEN_TIME },
      { goto: "frame12" }
    ]
  },
  {
    id: "frame12",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 12, time: Game.SPEARMEN_TIME },
      { goto: "frame13" }
    ]
  },
  {
    id: "frame13",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 13, time: Game.SPEARMEN_TIME },
      { goto: "frame14" }
    ]
  },
  {
    id: "frame14",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 14, time: Game.SPEARMEN_TIME },
      { goto: "frame15" }
    ]
  },
  {
    id: "frame15",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 15, time: Game.SPEARMEN_TIME },
      { goto: "frame16" }
    ]
  },
  {
    id: "frame16",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 16, time: Game.SPEARMEN_TIME },
      { goto: "frame17" }
    ]
  },

  {
    id: "frame17",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 17, time: Game.SPEARMEN_TIME },
      { goto: "frame18" }
    ]
  },
  {
    id: "frame18",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 18, time: Game.SPEARMEN_TIME },
      { goto: "frame19" }
    ]
  },
  {
    id: "frame19",
    sheet: "spearmen",
    flip: false,
    frames: [
      { row: 0, col: 19, time: Game.SPEARMEN_TIME }
    ]
  },

]

Game.LEVELS = [
  {
    level: 0,
    lasts: 0.125,
    spear: 120
  },
  {
    level: 1,
    lasts: 0.125,
    spear: 110
  },
  {
    level: 2,
    lasts: 0.125,
    spear: 100
  },
  {
    level: 3,
    lasts: 0.125,
    spear: 90
  },
  {
    level: 4,
    lasts: 0.125,
    spear: 80
  },
  {
    level: 5,
    lasts: 0.125,
    spear: 70
  },
  {
    level: 6,
    lasts: 0.125,
    spear: 60
  },
  {
    level: 7,
    lasts: 0.125,
    spear: 50
  },
]


Game.ENUM = 0;
Game.STATUS_CORNHOLIO_RUN = "run";
Game.STATUS_CORNHOLIO_CROUCH = "crouch";
Game.STATUS_CORNHOLIO_JUMP = "jump";
Game.STATUS_CORNHOLIO_DEAD = "dead";


Game.EVENT_DEAD = "eventDead";
Game.EVENT_WON = "eventWon";
Game.EVENT_GIVEUP = "eventGiveUp";

Game.ARROW_TIME = 1.4;
Game.ARROW_TIME_ALT = 1.4;
Game.DEBUG_NO_FIRE = false;


Game.MESSAGES_ANGRY = [
  "I CAN HEAR YOUR CURSES!",
  "DARK SOULS GAMES ARE NOTHING!",
  "C'MON THIS GAME IT'S SO EASY! :-)",
  "DON'T SAY BAD WORDS!",
  "DO NOT GET MAD!",
  "ANOTHER RUN! STAY A WHILE... STAY FOREVER!",
  "ANOTHER DAY ANOTHER TRY, BUT REMEMBER... DUCK, JUMP OR DIE!",
  "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARGH!",
  "ALL YOUR TEMPLE ARE BELONG TO US!",
  "YOU RUN LIKE A DAIRY FARMER!",
  "YOU SHALL NOT PASS!"
]

Game.MESSAGES_SPUR = [
  "WELL DONE! YOU'RE GETTING CLOSER!",
  "RUN CORNHOLIO RUN!",
  "KEEP IT UP!",
  "RUN TO THE TEMPLE, RUN FOR YOUR LIFE!",
  "DO NOT GIVE UP NOW!",
  "YOU CAN DO IT!",
  "FOCUS!"
]

Game.invincible = false;
Game.beginNearEnd = false;
Game.BLINK_COLORS = ["#FFFFFF", "#FF0000", "#00FFFF", "#FFFF00", "#FF00FF", "#00FF00"]
Game.EASIER = true;